import {BaseFormModel} from './base-form-model';

export class OrganizationTerminal extends BaseFormModel<OrganizationTerminal> {
    id: number;
    nickname: string;
    terminalId: string;
    parentId: number;
    promptTipOnReader: boolean;
}
